export default "__VITE_ASSET__c796277f__"